export enum DeviceStorageKey {
  CURRENT_PROFILE = 'currentProfile'
}

export type DeviceStorageKeys = keyof typeof DeviceStorageKey;
